/**
 * Per-user Backstage feature flag that gates the redesigned Insights page
 * (Figma "Insights - refresh") served at `/insights-refresh`. With the flag
 * off the route redirects to the existing `/insights` dashboard.
 *
 * Several figures on the page still render from placeholder data (see
 * `InsightsAndActions/INSIGHTS_REFRESH_DATA_REQUIREMENTS.md`), so it is off by
 * default. Registered in the yardstick-react plugin `featureFlags` array so it
 * appears in `/settings/feature-flags` at app bootstrap. Authored to satisfy
 * Backstage's `validateFlagName` (`/^[a-z]+[a-z0-9-]+$/`).
 */
export const INSIGHTS_REFRESH_FLAG_KEY = 'ys-insights-refresh';
